/**
 * /frontend/src/features/analytics/components/bottleneck/ZoneTrafficPieChart.js
 */

import React from 'react';
import ChartContainer from '../shared/ChartContainer';
import DistributionPieChart from '../charts/DistributionPieChart';

/**
 * Zone traffic distribution pie.
 * @param {{data:Array<{name:string,value:number}>}} props
 * @returns {JSX.Element}
 */
const ZoneTrafficPieChart = ({ data }) => (
  <ChartContainer title="Zone Traffic Distribution" subtitle="Share of joins by zone">
    <DistributionPieChart data={data} nameKey="name" valueKey="value" />
  </ChartContainer>
);

export default ZoneTrafficPieChart;

